export const MESSAGE_TYPE_RESOURCE_ENTRY = 'resource-entry';
export const MESSAGE_TYPE_HTTP_REQUEST_START = 'http-request-start';
export const MESSAGE_TYPE_HTTP_REQUEST_END = 'http-request-end';
export const MESSAGE_TYPE_DOM_MUTATION = 'dom-mutation';
